// A meeting has no sharing of its own (collaboration v1, PR 3 §1): who can see
// it is who can see its file, so every change goes through the file's sharing,
// the same call the Share dialog makes.
import { sharingApi } from './sharing-api';
import type { CompanyMeeting } from './types';
import { workspaceErrorCopy } from './workspace-errors';

/** Make the meeting's recording, and so the meeting, visible to its creator only. */
export function makeMeetingPrivate(
  meeting: Pick<CompanyMeeting, 'fileId' | 'sharingRevision'>,
  locale?: string,
) {
  if (!meeting.fileId) throw new Error(workspaceErrorCopy(locale).meetingRecording);
  return sharingApi.save({
    kind: 'file',
    id: meeting.fileId,
    visibility: 'private',
    audience: [],
    ...(meeting.sharingRevision ? { revision: meeting.sharingRevision } : {}),
  });
}

/** The meeting as the Share dialog sees it: its file's sharing. */
export const meetingShareItem = (meeting: CompanyMeeting) => ({
  id: meeting.fileId ?? '',
  title: meeting.title,
  visibility: meeting.visibility,
  audience: meeting.audience,
  sharingRevision: meeting.sharingRevision,
  createdBy: meeting.createdBy,
  canEdit: meeting.canEdit,
  canShare: meeting.canShare,
});
